import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tb_column_content" }
const _hoisted_2 = { style: {"margin-left":"10px"} }
const _hoisted_3 = { class: "tb_column_content" }
const _hoisted_4 = { style: {"margin-left":"10px"} }
const _hoisted_5 = { class: "tb_column_content" }
const _hoisted_6 = { style: {"margin-left":"10px"} }
const _hoisted_7 = { class: "tb_column_content" }
const _hoisted_8 = { style: {"margin-left":"10px"} }
const _hoisted_9 = { class: "tb_column_content" }
const _hoisted_10 = { style: {"margin-left":"10px"} }
const _hoisted_11 = { class: "tb_column_content" }
const _hoisted_12 = { style: {"margin-left":"10px"} }
const _hoisted_13 = { class: "tb_column_content" }
const _hoisted_14 = { style: {"margin-left":"10px"} }
const _hoisted_15 = { class: "tb_column_content" }
const _hoisted_16 = { style: {"margin-left":"10px"} }
const _hoisted_17 = { class: "tb_column_content" }
const _hoisted_18 = { style: {"margin-left":"10px"} }
const _hoisted_19 = { class: "tb_column_content" }
const _hoisted_20 = { style: {"margin-left":"10px"} }
const _hoisted_21 = { class: "tb_column_content" }

import {ref, toRefs} from 'vue';
import dayjs from 'dayjs';

// 格式化时间的函数

export default /*@__PURE__*/_defineComponent({
  __name: 'tb_content',
  props: {
    tableData: {},
    handleEdit: { type: Function },
    handleDelete: { type: Function },
    handleOder: { type: Function },
    total: {},
    currentPage: {},
    pageSize: {}
  },
  emits: ["page-change"],
  setup(__props: any, { emit: __emit }) {

const formatDate = (date: string) => {
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
};


// 定义 Props 接收父组件传来的数据和方法
const props = __props

const emit = __emit

const internalPage = ref(props.currentPage || 1)
const internalSize = ref(props.pageSize || 10)

const handleSizeChange = (val: number) => {
  internalSize.value = val
  emit('page-change', internalPage.value, internalSize.value)
}

const handleCurrentChange = (val: number) => {
  internalPage.value = val
  emit('page-change', internalPage.value, internalSize.value)
}

const formatIdCard = (idCard: string) => {
  if (!idCard) return '';
  // 保留前3位和后3位，中间用 * 替换
  return idCard.replace(/(\d{3})\d{10}(\w{3})/, '$1**********$2');
}

const formatPhone = (phone: string) => {
  if (!phone) return '';
  // 保留前3位和后4位，中间4位用 * 替换
  return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
}

const changeDrange = (index: number) => {
  tableData.value[index].isD = true;
}

const formatState = (state: string) => {
  if (!state) return '';
  if (state === "0") {
    return "支付成功"
  } else if (state === "1") {
    return "支付同步中"
  } else if (state === "2") {
    return "支付失败"
  } else if (state === "3") {
    return "发起退款"
  } else if (state === "4") {
    return "退款成功"
  } else if (state === "5") {
    return "退款失败"
  } else if (state === "6") {
    return "已解绑"
  } else if (state === "7") {
    return "订单完成"
  }
  return;
}
// 解构 props 以便在模板中使用
const {tableData, handleEdit, handleDelete, handleOder} = toRefs(props)

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    data: _unref(tableData),
    style: {"width":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        label: "申请手机号",
        align: "center",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(scope.row.phone), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "申请理由",
        align: "center",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(scope.row.description), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "申请时间",
        align: "center",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(scope.row.create_time), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "请求流水号",
        "header-align": "center",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(scope.row.reqSeqId), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "身份证号",
        "header-align": "center",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(formatIdCard(scope.row.idCardNo)), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "金额(元)",
        align: "center",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(scope.row.price), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "支付日期",
        "header-align": "center",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(formatDate(scope.row.payTime)), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "退款日期",
        "header-align": "center",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(scope.row.rePayTime ? formatDate(scope.row.rePayTime) : scope.row.rePayTime), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "支付平台",
        "header-align": "center",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, _toDisplayString(scope.row.type == "0" ? "汇付" : "宝付"), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "订单状态",
        "header-align": "center",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", _hoisted_20, _toDisplayString(formatState(scope.row.state)), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "操作",
        "header-align": "center",
        width: "300"
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_el_button, {
              size: "small",
              type: "danger",
              disabled: scope.row.state==6,
              onClick: ($event: any) => (_unref(handleDelete)(scope.$index, scope.row))
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" 退订 ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            (!scope.row.isD)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  size: "small",
                  disabled: scope.row.state==4||scope.row.state==6||scope.row.state==3,
                  onClick: ($event: any) => (_unref(handleEdit)(scope.$index, scope.row))
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" 退费 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  size: "small",
                  onClick: ($event: any) => (_unref(handleEdit)(scope.$index, scope.row))
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" 退费 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])),
            _createVNode(_component_el_button, {
              size: "small",
              color: "red",
              onClick: ($event: any) => (changeDrange( scope.$index))
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" 紧急 ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              size: "small",
              color: "red",
              onClick: ($event: any) => (_unref(handleOder)(scope.$index, scope.row))
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" 已处理 ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})